import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './Pagination.module.scss';
import { useResultListContext } from 'common/contexts/ResultListContext';
import {ReactComponent as Arrow} from '../../../../assets/icons/arrowBold.svg'

interface PaginationProps {
  perPage?: number;
  numPages: number | undefined;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
                                                 numPages = 1,
                                                 onPageChange,
                                               }) => {
  let startPage = 1;
  let endPage = numPages;
  let maxPages = 5;

  const { currentPage } = useResultListContext();

  const isMobile = useMediaQuery({ maxWidth: 590 });
  if (isMobile) {
    maxPages = 3;
  }

  if (numPages === 1) {
    return null;
  }

  if (numPages > maxPages) {
    const middle = Math.ceil(maxPages / 2);
    if (currentPage <= middle) {
      endPage = maxPages;
    } else if (currentPage + middle >= numPages) {
      startPage = numPages - maxPages + 1;
    } else {
      startPage = currentPage - middle + 1;
      endPage = currentPage + middle - 1;
    }
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  return (
      <nav className={styles.container}>
        <ul className={styles.container__pagination}>
          {currentPage > 1 && (
              <li className={styles.page_item}>
                <a
                    href={`?page=${currentPage - 1}`}
                    className={styles.page_link}
                    onClick={(e) => {
                      e.preventDefault()
                      onPageChange(currentPage - 1)
                    }}
                >
                  <Arrow />
                </a>
              </li>
          )}

          {pages.map((page) => (
              <li
                  key={page}
                  className={page === currentPage ? styles.page_item_active : styles.page_item}
              >
                <a
                    href={`?page=${page}`}
                    className={styles.page_link}
                    onClick={(e) => {
                      e.preventDefault()
                      onPageChange(page)
                    }}
                >
                  {page}
                </a>
              </li>
          ))}

          {currentPage < numPages && (
              <li className={styles.page_item}>
                <a
                    href={`?page=${currentPage + 1}`}
                    className={styles.page_link}
                    onClick={(e) => {
                      e.preventDefault()
                      onPageChange(currentPage + 1)
                    }}
                >
                  <Arrow style={{ transform: 'rotate(180deg)' }} />
                </a>
              </li>
          )}
        </ul>
      </nav>

  );
};

export default Pagination;